import type { DiagnosticJobKind } from "@/api/adminDiagnosticJob";

// 진단 잡 종류의 표시 문구. 목록·상세·필터가 같은 문구를 쓴다.
const labels: Record<DiagnosticJobKind, string> = {
  parquet: "재진단",
  aggregate: "집계",
  video: "영상 진단",
};

export function diagnosticJobKindLabel(kind: DiagnosticJobKind): string {
  return labels[kind];
}
